import * as React from 'react';

import type { IconProps } from '../types';

const StatusInProgress = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="hsl(var(--twc-status-icon-in-progress))"
          d="M8 1.57768C8 1.30483 8.22147 1.08181 8.49362 1.10128C9.23293 1.15418 9.96005 1.32566 10.6468 1.61013C11.486 1.95771 12.2484 2.46718 12.8907 3.10943C13.5329 3.75168 14.0424 4.51414 14.39 5.35329C14.6744 6.04005 14.8459 6.76716 14.8988 7.50648C14.9183 7.77863 14.6953 8.0001 14.4224 8.0001L8.49403 8.0001C8.22119 8.0001 8 7.77891 8 7.50606V1.57768Z"
        />
      </svg>
    );
  }
);

StatusInProgress.displayName = 'StatusInProgress';

export { StatusInProgress };
